import styled from "@emotion/styled";
import {
  Alert,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  tableCellClasses,
  Modal,
  Box,
  MenuItem,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import LibraryMusicIcon from "@mui/icons-material/LibraryMusic";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { VscMail } from "react-icons/vsc";
import { Send } from "@mui/icons-material";
import GlobalHeader from "../../../components/GlobalHeader";
import { useEffect } from "react";
import useApi from "../../../hooks/useApi";
import { useState } from "react";
import Audio from "react-loading-icons/dist/esm/components/audio";
import { LoadingButton } from "@mui/lab";
import useSnack from "../../../hooks/useSnack";
import SubirImagenPerfil from "../../../components/SubirImagenPerfil";
import SnackAlert from "../../../components/SnackAlert";
import {
  TIPOS_ARTISTA,
  gestionaMultiplesArtistas,
} from "../../../utils/tiposArtista";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    textAlign: "center",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textAlign: "center",
    padding: "5px 0",
  },
}));

//f
//style modal
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "20px",
};

const StyledTableRow = styled(TableRow)(({ theme }) => ({}));

const UsersAdmin = () => {
  const navigate = useNavigate();
  const { loadApi, loadingApi } = useApi();
  const [productores, setProductores] = useState([]);
  const [artistas, setArtistas] = useState([]);
  const [data, setData] = useState({});
  const [open, setOpen] = useState(false);
  const { showSnack, openSB, typeSB, msgSB } = useSnack();
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [searchProductores, setSearchProductores] = useState();
  const [searchArtistas, setSearchArtistas] = useState();
  const [product, setProduct] = useState(false);
  const [artist, setArtist] = useState(false);

  //load api productores
  useEffect(() => {
    loadApi("admin/profiles/productores", true, "get")
      .then((res) => {
        setProductores(res.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [product]);

  //load api artistas
  useEffect(() => {
    loadApi("admin/profiles/artistas", true, "get")
      .then((res) => {
        setArtistas(res.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [artist]);

  //cerrar
  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    loadApi("admin/correo", true, "post", data)
      .then((res) => {
        showSnack(res.data.message, "success");
        setOpen(false);
      })
      .catch((e) => {
        showSnack(e.message, "error");
      });
  };

  //Eliminación total de un usuario (con confirmación por email)
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState("");

  const openDelete = (item) => {
    setDeleteTarget(item);
    setDeleteConfirm("");
  };

  const emailCoincide =
    deleteTarget &&
    deleteConfirm.trim().toLowerCase() === deleteTarget.username.toLowerCase();

  const handleDeleteUser = () => {
    loadApi(`admin/users/${deleteTarget.id}`, true, "delete", {
      confirmEmail: deleteConfirm.trim().toLowerCase(),
    })
      .then((res) => {
        if (deleteTarget.role === "productor")
          setProductores((prev) =>
            prev.filter((u) => u.id !== deleteTarget.id)
          );
        else
          setArtistas((prev) => prev.filter((u) => u.id !== deleteTarget.id));
        setDeleteTarget(null);
        showSnack(res.data.message, "success");
      })
      .catch((e) => {
        showSnack(e.message, "error");
      });
  };

  // Edición admin de perfil de difusor (redes + foto) — PROVISIONAL, ver
  // Backend/src/routes/admin/profileEdit.js.
  const [editTarget, setEditTarget] = useState(null);
  const [editForm, setEditForm] = useState({});

  const openEdit = (item) => {
    setEditTarget(item);
    setEditForm({
      facebook: item.profile?.facebook || "",
      instagram: item.profile?.instagram || "",
      youtube: item.profile?.youtube || "",
      spotify: item.profile?.spotify || "",
      tiktok: item.profile?.tiktok || "",
      twitter: item.profile?.twitter || "",
      twitch: item.profile?.twitch || "",
    });
  };

  const handleGuardarEdit = () => {
    loadApi(`admin/profile_edit/${editTarget.id}`, true, "put", editForm)
      .then((res) => {
        showSnack(res.data.message);
        setEditTarget(null);
        setProduct((p) => !p); // recarga la lista de productores
      })
      .catch((e) => showSnack(e.message, "error"));
  };

  // Cambio de tipo de ecosistema (p. ej. de solista a manager o RP), para no
  // obligar a borrar la cuenta y registrarse de nuevo.
  const [tipoTarget, setTipoTarget] = useState(null);
  const [nuevoTipo, setNuevoTipo] = useState("Manager o RP");

  const openCambiarTipo = (item) => {
    setTipoTarget(item);
    setNuevoTipo(
      item.profile?.tipo === "Manager o RP" ? "" : "Manager o RP"
    );
  };

  const handleCambiarTipo = () => {
    loadApi(`admin/profiles/artistas/${tipoTarget.id}/tipo`, true, "put", {
      tipo: nuevoTipo,
    })
      .then((res) => {
        showSnack(res.data.message);
        setTipoTarget(null);
        setArtist((a) => !a); // recarga la lista de músicos
      })
      .catch((e) => showSnack(e.message, "error"));
  };

  const pasaAMultiartista =
    tipoTarget &&
    nuevoTipo &&
    !gestionaMultiplesArtistas(tipoTarget.profile?.tipo) &&
    gestionaMultiplesArtistas(nuevoTipo);

  //search productores
  const handleSearch = (value) => {
    clearTimeout(typingTimeout);
    setSearchProductores(value);

    if (value) {
      const newTypingTimeout = setTimeout(() => {
        const filteredPeople = productores.filter((person) =>
          person.profile?.nombre_media
            .toLowerCase()
            .includes(value.toLowerCase())
        );
        setProductores(filteredPeople);
      }, 1000);

      setTypingTimeout(newTypingTimeout);
    } else setProduct(!product);
  };

  //search artistas
  const handleSearchArt = (value) => {
    clearTimeout(typingTimeout);
    setSearchProductores(value);

    if (value) {
      const newTypingTimeout = setTimeout(() => {
        const filteredPeople = artistas.filter((person) =>
          person.profile?.nombre_media
            .toLowerCase()
            .includes(value.toLowerCase())
        );
        setArtistas(filteredPeople);
      }, 1000);

      setTypingTimeout(newTypingTimeout);
    } else setArtist(!artist);
  };

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Stack spacing={1}>
            <Typography variant="h6" textAlign="center">
              Enviar correo
            </Typography>
            <Stack spacing={2}>
              <TextField
                type="email"
                label="Para"
                value={data.to}
                variant="filled"
                onChange={(e) =>
                  setData((adata) => ({
                    ...adata,
                    to: e.target.value.toLowerCase(),
                  }))
                }
              ></TextField>
              <TextField
                type="text"
                label="Asunto"
                variant="filled"
                onChange={(e) =>
                  setData((adata) => ({ ...adata, subject: e.target.value }))
                }
              ></TextField>
              <TextField
                multiline
                type="text"
                rows={6}
                label="descripcion"
                onChange={(e) =>
                  setData((adata) => ({
                    ...adata,
                    description: e.target.value,
                  }))
                }
              ></TextField>
            </Stack>
            <Stack direction="row" justifyContent="flex-end">
              <LoadingButton
                loading={loadingApi.includes("post__admin/correo")}
                onClick={handleSubmit}
                endIcon={<Send />}
                sx={{ px: "24px" }}
              >
                Enviar
              </LoadingButton>
            </Stack>
          </Stack>
        </Box>
      </Modal>
      <GlobalHeader />
      <Container>
        <Stack pb={6}>
          <Typography variant="h4">Difusores</Typography>
          <Stack alignItems="end" sx={{ gap: "20px" }}>
            <TextField
              variant="outlined"
              placeholder="Buscar por nombre media"
              onChange={(e) => handleSearch(e.target.value)}
            ></TextField>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell> # </StyledTableCell>
                    <StyledTableCell> Nombre </StyledTableCell>
                    <StyledTableCell> Nombre del medio </StyledTableCell>
                    <StyledTableCell> Email </StyledTableCell>
                    <StyledTableCell> Tipo de difusor </StyledTableCell>
                    <StyledTableCell> RadarCoins (USD) </StyledTableCell>
                    <StyledTableCell> Acciones </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loadingApi.includes("get__admin/profiles/productores") &&
                    productores.length === 0 && (
                      <StyledTableRow>
                        <StyledTableCell colSpan={7}>
                          <Audio fill="#F27224" />
                        </StyledTableCell>
                      </StyledTableRow>
                    )}

                  {!loadingApi.includes("get__admin/profiles/productores") &&
                  productores.length === 0 ? (
                    <StyledTableRow>
                      <StyledTableCell colSpan={7}>
                        <Typography variant="h5">No hay resultados</Typography>
                      </StyledTableCell>
                    </StyledTableRow>
                  ) : (
                    productores.map((item, i) => (
                      <StyledTableRow key={i}>
                        <StyledTableCell>{i + 1}</StyledTableCell>
                        <StyledTableCell>{item.name}</StyledTableCell>
                        <StyledTableCell>
                          {item.profile.nombre_media}
                        </StyledTableCell>
                        <StyledTableCell>{item.username}</StyledTableCell>
                        <StyledTableCell>{item.profile.tipo}</StyledTableCell>
                        <StyledTableCell>
                          ${item.profile.credits}USD
                        </StyledTableCell>
                        <StyledTableCell
                          sx={{
                            display: "flex",
                            gap: "5px",
                            justifyContent: "center",
                          }}
                        >
                          <Button
                            onClick={() =>
                              navigate(`/admin/users/canciones/${item.id}`)
                            }
                          >
                            <LibraryMusicIcon />
                          </Button>
                          <Button
                            onClick={() => {
                              setData({ to: item.username, userId: item.id });
                              setOpen(true);
                            }}
                            sx={{ fontSize: "26px" }}
                          >
                            <VscMail />
                          </Button>
                          {/* PROVISIONAL — ver Backend/src/routes/admin/profileEdit.js */}
                          <Button onClick={() => openEdit(item)}>
                            <EditIcon />
                          </Button>
                          <Button color="error" onClick={() => openDelete(item)}>
                            <DeleteForeverIcon />
                          </Button>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Stack>
        </Stack>
        <Stack pb={6}>
          <Typography variant="h4">Musicos</Typography>
          <Stack alignItems="end" sx={{ gap: "20px" }}>
            <TextField
              variant="outlined"
              placeholder="Buscar por nombre media"
              onChange={(e) => handleSearchArt(e.target.value)}
            ></TextField>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell> # </StyledTableCell>
                    <StyledTableCell> Nombre </StyledTableCell>
                    <StyledTableCell> Email </StyledTableCell>
                    <StyledTableCell> Email de contacto </StyledTableCell>
                    <StyledTableCell> Nombre encargado </StyledTableCell>
                    <StyledTableCell> Nombre media </StyledTableCell>
                    <StyledTableCell> Tipo </StyledTableCell>
                    <StyledTableCell> RadarCoins </StyledTableCell>
                    <StyledTableCell> RC comprados </StyledTableCell>
                    <StyledTableCell> RC de bonos </StyledTableCell>
                    <StyledTableCell> Acciones </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loadingApi.includes("get__admin/profiles/artistas") &&
                    artistas.length === 0 && (
                      <StyledTableRow>
                        <StyledTableCell colSpan={9}>
                          <Audio fill="#F27224" />
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                  {!loadingApi.includes("get__admin/profiles/artistas") &&
                  artistas.length === 0 ? (
                    <StyledTableRow>
                      <StyledTableCell colSpan={8}>
                        <Typography variant="h5">No hay resultados</Typography>
                      </StyledTableCell>
                    </StyledTableRow>
                  ) : (
                    artistas.map((item, i) => (
                      <StyledTableRow key={i}>
                        <StyledTableCell>{i + 1}</StyledTableCell>
                        <StyledTableCell>{item.name}</StyledTableCell>
                        <StyledTableCell>{item.username}</StyledTableCell>
                        <StyledTableCell>
                          {item.profile.email_contacto}
                        </StyledTableCell>
                        <StyledTableCell>
                          {item.profile.nombre_encargado}
                        </StyledTableCell>
                        <StyledTableCell>
                          {item.profile.nombre_media}
                        </StyledTableCell>
                        <StyledTableCell>{item.profile.tipo}</StyledTableCell>
                        <StyledTableCell>
                          {item.profile.credits}RC
                        </StyledTableCell>
                        <StyledTableCell>{item.rcComprados ?? 0}RC</StyledTableCell>
                        <StyledTableCell>{item.rcBonos ?? 0}RC</StyledTableCell>
                        <StyledTableCell>
                          <Button
                            onClick={() => {
                              setData({ to: item.username, userId: item.id });
                              setOpen(true);
                            }}
                            sx={{ fontSize: "26px" }}
                          >
                            <VscMail />
                          </Button>
                          <Button
                            title="Cambiar tipo de ecosistema"
                            onClick={() => openCambiarTipo(item)}
                          >
                            <SwapHorizIcon />
                          </Button>
                          <Button color="error" onClick={() => openDelete(item)}>
                            <DeleteForeverIcon />
                          </Button>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Stack>
        </Stack>
      </Container>
      {/* Cambio de tipo de ecosistema */}
      <Dialog
        open={Boolean(tipoTarget)}
        onClose={() => setTipoTarget(null)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          Cambiar tipo —{" "}
          {tipoTarget?.profile?.nombre_media || tipoTarget?.name}
        </DialogTitle>
        <DialogContent>
          <Stack gap={2} pt={1}>
            <Typography variant="body2">
              Tipo actual: <strong>{tipoTarget?.profile?.tipo || "—"}</strong>
            </Typography>
            <TextField
              select
              label="Nuevo tipo"
              value={nuevoTipo}
              onChange={(e) => setNuevoTipo(e.target.value)}
              fullWidth
            >
              {TIPOS_ARTISTA.filter(
                (tipo) => tipo !== tipoTarget?.profile?.tipo
              ).map((tipo) => (
                <MenuItem key={tipo} value={tipo}>
                  {tipo}
                </MenuItem>
              ))}
            </TextField>
            <Alert severity="info">
              Conserva la cuenta, sus RC, sus canciones y su historial de
              envíos: solo cambia el tipo de ecosistema musical.
              {pasaAMultiartista &&
                " Como pasa a gestionar varios artistas, va a tener el menú Artistas para armar su roster; lo que ya subió queda a nombre de su perfil, sin artista asignado."}
            </Alert>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ pb: 2, px: 3 }}>
          <Button variant="text" onClick={() => setTipoTarget(null)}>
            Cancelar
          </Button>
          <LoadingButton
            variant="contained"
            disabled={!nuevoTipo}
            loading={loadingApi.includes(
              `put__admin/profiles/artistas/${tipoTarget?.id}/tipo`
            )}
            onClick={handleCambiarTipo}
          >
            Cambiar tipo
          </LoadingButton>
        </DialogActions>
      </Dialog>
      {/* Confirmación de eliminación total */}
      <Dialog
        open={Boolean(deleteTarget)}
        onClose={() => setDeleteTarget(null)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle color="error">
          Eliminar por completo a {deleteTarget?.name}
        </DialogTitle>
        <DialogContent>
          <Stack gap={2}>
            <Alert severity="error">
              Se eliminará todo el rastro del usuario: perfil, canciones,
              envíos, notificaciones, pagos, retiros y sus archivos. Sus
              movimientos financieros quedan respaldados en el archivo
              contable antes de borrar. Esta acción no se puede deshacer.
            </Alert>
            <TextField
              type="email"
              label={`Escribe el email (${deleteTarget?.username || ""}) para confirmar`}
              value={deleteConfirm}
              onChange={(e) => setDeleteConfirm(e.target.value)}
              fullWidth
            />
          </Stack>
        </DialogContent>
        <DialogActions sx={{ pb: 2, px: 3 }}>
          <Button variant="text" onClick={() => setDeleteTarget(null)}>
            Cancelar
          </Button>
          <LoadingButton
            color="error"
            disabled={!emailCoincide}
            loading={loadingApi.includes(
              `delete__admin/users/${deleteTarget?.id}`
            )}
            onClick={handleDeleteUser}
          >
            Eliminar definitivamente
          </LoadingButton>
        </DialogActions>
      </Dialog>
      {/* Edición admin de perfil de difusor — PROVISIONAL, ver
          Backend/src/routes/admin/profileEdit.js. Quitar este Dialog, el
          botón que lo abre, sus estados/handlers y el archivo del backend
          en cuanto se apliquen las correcciones puntuales. */}
      <Dialog
        open={Boolean(editTarget)}
        onClose={() => setEditTarget(null)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          Editar perfil — {editTarget?.profile?.nombre_media || editTarget?.name}
        </DialogTitle>
        <DialogContent>
          <Stack gap={2} pt={1}>
            {editTarget && (
              <SubirImagenPerfil
                tipo="profileimg"
                endpoint={`admin/profile_edit/${editTarget.id}`}
                currentImage={editTarget.profile?.profileimg}
                showSnack={showSnack}
              />
            )}
            <TextField
              label="Facebook"
              value={editForm.facebook || ""}
              onChange={(e) =>
                setEditForm((f) => ({ ...f, facebook: e.target.value }))
              }
              fullWidth
            />
            <TextField
              label="Instagram"
              value={editForm.instagram || ""}
              onChange={(e) =>
                setEditForm((f) => ({ ...f, instagram: e.target.value }))
              }
              fullWidth
            />
            <TextField
              label="YouTube"
              value={editForm.youtube || ""}
              onChange={(e) =>
                setEditForm((f) => ({ ...f, youtube: e.target.value }))
              }
              fullWidth
            />
            <TextField
              label="Spotify"
              value={editForm.spotify || ""}
              onChange={(e) =>
                setEditForm((f) => ({ ...f, spotify: e.target.value }))
              }
              fullWidth
            />
            <TextField
              label="TikTok"
              value={editForm.tiktok || ""}
              onChange={(e) =>
                setEditForm((f) => ({ ...f, tiktok: e.target.value }))
              }
              fullWidth
            />
            <TextField
              label="X (Twitter)"
              value={editForm.twitter || ""}
              onChange={(e) =>
                setEditForm((f) => ({ ...f, twitter: e.target.value }))
              }
              fullWidth
            />
            <TextField
              label="Twitch"
              value={editForm.twitch || ""}
              onChange={(e) =>
                setEditForm((f) => ({ ...f, twitch: e.target.value }))
              }
              fullWidth
            />
          </Stack>
        </DialogContent>
        <DialogActions sx={{ pb: 2, px: 3 }}>
          <Button onClick={() => setEditTarget(null)}>Cerrar</Button>
          <LoadingButton
            variant="contained"
            loading={loadingApi.includes(
              `put__admin/profile_edit/${editTarget?.id}`
            )}
            onClick={handleGuardarEdit}
          >
            Guardar redes
          </LoadingButton>
        </DialogActions>
      </Dialog>
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
    </>
  );
};

export default UsersAdmin;
